export default function ErrorMsg({ message }) {
  return (
    <div className="form-msg--err">
      <p>{message}</p>
    </div>
  );
}
